var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pricegroups-wrapper mx-auto mt-5"},_vm._l((Object.keys(_vm.pricegroups)),function(p){return _c('div',[_c('select-pricegroup-tickets-amount',{attrs:{"pricegroup":_vm.pricegroups[p]}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }